module.exports = __webpack_public_path__ + "static/media/logo_complet._Olassist.1b29fdc7.png";